import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiErrorResponse, ApiResponse, ApiServiceInterface } from '@hutsix/ngxh6';

interface HostConfirmDetails {
    permitType: string;
    applicantName: string;
    hostName?: string;
    confirmed: boolean;
}

/**
 * Host verification landing (no login). A host arrives via the emailed link
 * (/host-confirm/:token), sees who applied, and confirms with a button - the
 * confirmation is a POST so an email client's link-preview can't confirm by
 * accident.
 */
@Component({
    selector: 'app-host-confirm',
    templateUrl: './host-confirm.component.html',
    styleUrls: ['./host-confirm.component.scss'],
    standalone: false,
})
export class HostConfirmComponent implements OnInit {
    public details?: HostConfirmDetails | null;
    public loading = true;
    public notFound = false;
    public submitting = false;
    public confirmed = false;
    public error?: string | null;
    private token?: string;

    constructor(
        @Inject('ApiService') private api: ApiServiceInterface,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.token = this.route.snapshot.paramMap.get('token') || undefined;
        this.api
            .get({ url: `/api/public/permit/host-confirm/${this.token}`, skipAuth: true, bypassOfflineQueue: true, useCache: false, displayErrors: false })
            .subscribe(
                (res: ApiResponse<HostConfirmDetails>) => {
                    this.loading = false;
                    this.details = res.data;
                    this.confirmed = !!res.data.confirmed;
                },
                (_err: ApiErrorResponse<any>) => {
                    this.loading = false;
                    this.notFound = true;
                },
            );
    }

    public confirm(): void {
        this.submitting = true;
        this.error = null;
        this.api.post({ url: `/api/public/permit/host-confirm/${this.token}`, data: {}, skipAuth: true, offline: false, displayErrors: false }).subscribe(
            () => {
                this.submitting = false;
                this.confirmed = true;
            },
            (err: ApiErrorResponse<any>) => {
                this.submitting = false;
                this.error = err.error?.error?.error || err.message || 'Something went wrong, please try again.';
            },
        );
    }
}
